import type { InputHTMLAttributes } from 'react';
import * as SwitchPrimitive from '@radix-ui/react-switch';

import { cls } from '@/utils/cls';

export type SwitchProps = Pick<
  InputHTMLAttributes<HTMLInputElement>,
  | 'id'
  | 'disabled'
  | 'name'
  | 'required'
  | 'readOnly'
  | 'aria-label'
  | 'aria-labelledby'
> & {
  value: boolean;
  onChange: (checked: boolean) => void;
};

export function Switch({ value, onChange, disabled, ...props }: SwitchProps) {
  return (
    <SwitchPrimitive.Root
      checked={value}
      onCheckedChange={onChange}
      disabled={disabled}
      className={cls(
        'relative h-5 w-9 cursor-pointer rounded-full bg-gray-300 transition-colors',
        value && 'bg-primary-500',
        disabled && 'cursor-not-allowed opacity-50',
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        className={cls(
          'block h-4 w-4 translate-x-1 rounded-full bg-white transition-transform',
          value && 'translate-x-4',
        )}
      />
    </SwitchPrimitive.Root>
  );
}
